






































































































































import { Popup } from '@questelservices/common-vue';
import { Prop } from 'vue-property-decorator';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxList, DxLookup,DxPopup , DxSelectBox} from 'devextreme-vue';
import CustomStore from 'devextreme/data/custom_store';
import { TextTemplateTypeEnum } from '@/models/TextTemplateTypeEnum';
import { TextTemplateService } from '@/service/TextTemplateService';
import { DxHtmlEditor, DxItem, DxToolbar } from 'devextreme-vue/html-editor';
import { DxValidator, DxRequiredRule, DxStringLengthRule } from 'devextreme-vue/validator';
import { TextTemplateDto } from '@/models/TextTemplateDto';
import _ from 'lodash';
import dialog from 'devextreme/ui/dialog';
import Lookup from 'devextreme/ui/lookup';
import dxHtmlEditor from 'devextreme/ui/html_editor';
import DxValidationGroup from 'devextreme-vue/validation-group';
import ValidationGroup from 'devextreme/ui/validation_group';
import String from '@/utilities/String';
import * as overlay from 'devextreme/ui/overlay';

const editorStatus = {
    valid : 'valid',
    invalid : 'invalid',
    pending : 'pending'
}

const validationRule = {
    requiredError  : {
        message : 'This is required.'
    },
    existError : {
        message : 'This already exists.'
    },
    noError : {}
}

@Component({
  components: {
    Popup,
    DxLookup,
    DxList,
    DxToolbarItem,
    DxHtmlEditor,
    DxItem,
    DxToolbar,
    DxValidator,
    DxRequiredRule,
    DxStringLengthRule,
    DxValidationGroup,
    DxPopup,
    DxSelectBox
  }
})
export default class EmailTemplateEditor extends Vue {
  $refs: Vue['$refs'] & {
        savedTypeTemplateRef?: Lookup;
        savedTextTemplateRef?: Lookup;
        textAreaRef?: DxHtmlEditor;
        validationGroupRef? : ValidationGroup;
    } = {};

    @Prop({ default: false })
    showDialog!: boolean;

    get showingDialog() {
        return this.showDialog;
    }

    set showingDialog(value) {            
        this.$emit("hiding");
    }

    private get savedTypeTemplate() {
        return ((this.$refs.savedTypeTemplateRef as Lookup).instance as any); 
    }

    private get savedTextTemplate() {
        return ((this.$refs.savedTextTemplateRef as Lookup).instance as any); 
    }

    private get textArea() {
        return (this.$refs.textAreaRef as DxHtmlEditor).instance as dxHtmlEditor;
    }

    private get validationGroup() {
        return ((this.$refs.validationGroupRef as ValidationGroup).instance as any); 
    }    

    selectedText: Guid = '';    
    textTemplateStore: CustomStore | Array<any> = [];
    textTemplateService : TextTemplateService;
    textTemplateType : Array<any>;
    allAvailableAutoText: CustomStore;
    nameValue: string = '';
    textTemplate : TextTemplateDto;
    saveOrUpdate : string = "Save";
    showConfirmation: boolean = false;

    availableAutoText(type: TextTemplateTypeEnum | number | undefined = undefined) {
        return new CustomStore({
            loadMode: 'raw',
            load: (options): Promise<string[]> => {
              if(type) {
                return this.textTemplateService.getAvailableAutoText(type)
                    .then((results: string[]) => {
                        return results;
                      }                    
                    )
                    .catch(err=> []);
              }
              else {
                return Promise.resolve([]);
              }
            }            
        });
    }
    
    templateStore(type: TextTemplateTypeEnum | number | undefined = undefined) {
        return new CustomStore({
            loadMode: 'raw',
            load: (options): Promise<any> => {
              if(type) {
                return this.textTemplateService.getTextTemplate(type)
                    .then((results : any) => {
                        return results;
                    }
                    
                    )
                    .catch(err=> []);
              }
              else {
                return Promise.resolve([]);
              }
            }
        });
    }

    constructor() {
      super();
      this.textTemplate = this.defaultValue();
      this.textTemplateService = new TextTemplateService();
      this.allAvailableAutoText = this.availableAutoText();
      this.textTemplateType = [];
      overlay.baseZIndex(2000);
    }

    private defaultValue(textVal: string = ""): TextTemplateDto {
      return {
        TextTemplateId: "00000000-0000-0000-0000-000000000000",
        Name: "",
        Text: textVal,
        Favorite: false        
      }
    }

    onSelectionTextChanged(e:any) {      
      if(e.selectedItem) {
            this.textTemplate.Text = e.selectedItem.Text;
            this.textTemplate.Name = e.selectedItem.Name;
            this.nameValue = e.selectedItem.Name;
            this.textTemplate.Favorite = e.selectedItem.Favorite;
            this.textTemplate.TextTemplateId = e.selectedItem.TextTemplateId;
            this.saveOrUpdate = "Update";
            this.saveAsOption =this.textBoxOption(true, editorStatus.valid, validationRule.noError);
            this.saveAsOption.value = e.selectedItem.Name;

            this.textArea.option('value', e.selectedItem.Text);
            let length = this.textArea.getLength();
            this.textArea.getQuillInstance().selection.setRange({ index: length, length: 0 });
        }

        if(!this.selectedText) {
            this.onNew(e.selectedItem);
        }
    }
    
    onSelectionChanged(e:any) {
      if(e.selectedItem) {
        this.textTemplateStore = this.templateStore(e.selectedItem.key);
        this.allAvailableAutoText = this.availableAutoText(e.selectedItem.key);
      }
      else {
        this.textTemplateStore = [];
        this.onNew(e.selectedItem);
      }
    }

    saveAsOption: any = this.textBoxOption();

    textBoxOption(valid: boolean = true, 
            status: string = editorStatus.valid,
            error: any = validationRule.noError) {

            
        return {
            width: '200px',
            placeholder:'Save as',
            value: this.nameValue,
            validationStatus: status,
            validationError : error,
            onValueChanged: this.onValueChanged,
            isValid : valid,
            maxLength: 50,
            onFocusOut: this.onFocusOut,
            valueChangeEvent: 'keyup'
        }
    }

    onFocusOut(e: any) {
      if (String.isNullOrEmpty(this.nameValue)) {
        this.saveAsOption = this.textBoxOption(false, editorStatus.invalid, validationRule.requiredError);
      }
    }

    onNew(itemSelected: any) {      
      this.saveOrUpdate = "Save";
        // need to save this to a temp variable so that we can set
        // it back after it's being cleared when calling this.defaultValue
      const tempTextTemplateTypeId = this.textTemplate.TextTemplateTypeId;
      this.textTemplate = this.defaultValue();
      this.textTemplate.TextTemplateTypeId = tempTextTemplateTypeId;
      this.selectedText = '';
      this.nameValue = '';
      if(itemSelected) {
        this.saveAsOption = this.textBoxOption(false,editorStatus.invalid, validationRule.requiredError);
      }
      else{
        this.saveAsOption = this.textBoxOption();
      }
    }

    onValueChanged(e: any) {
      this.nameValue = e.value;
      if (!String.isNullOrEmpty(this.nameValue)) {
        if (!this.saveAsOption.isValid) {
          this.saveAsOption.isValid = true;
          this.saveAsOption.validationStatus = editorStatus.valid;
          this.saveAsOption.validationError = validationRule.noError;

          e.component.option('isValid', this.saveAsOption.isValid);
          e.component.option('validationStatus', this.saveAsOption.validationStatus);
          e.component.option('validationError', this.saveAsOption.validationError);
        }
      }
    }

    onAvailableAutoTextChanged(e: any) {
        if (e.addedItems != null && e.addedItems.length > 0) {
          let index = this.textArea.getQuillInstance().selection.savedRange.index;

          this.textArea.insertText(index, e.addedItems[0], {});
          let newIndex = index + e.addedItems[0].length;

          this.textArea.setSelection(newIndex, 0);
          e.component.instance().unselectAll();
        }
    }

    saveEmailTemplate(e: any) {
      this.toSave(false);
    }
    forNew(evnt: any) {
        this.toSave(true);
    }

    async toSave(isForNew: boolean) {      
       var isValid = true;
        if(!this.nameValue && !this.textTemplate.Name){
            this.saveAsOption = this.textBoxOption(false,editorStatus.invalid, validationRule.requiredError);
            isValid = false;
        }
        let validate = this.validationGroup.validate();

        if(!validate.isValid) {
          isValid = false;
        }

        if (this.textArea.option('isValid') === false) {
          isValid = false;
        }

        if(isValid) {
          this.showConfirmation = true;
            let result = await dialog.confirm("Are you sure?", "Confirm Changes");            
            if(result) {
                let payload = _.clone(this.textTemplate);
                if(isForNew) {
                    payload.TextTemplateId = this.defaultValue().TextTemplateId;
                }

                this.saveAsOption = this.textBoxOption(true,editorStatus.pending);
                if(this.nameValue !== payload.Name || isForNew) {
                    payload.Name = this.nameValue;

                    this.textTemplateService.checkIfExists(payload.Name, payload.TextTemplateTypeId)
                        .then(result => {                          
                            if (result.Data === true) {
                                this.saveAsOption = this.textBoxOption(false, editorStatus.invalid, validationRule.existError);
                            } else {
                                this.newUpdateOrSave(payload);
                            }
                        })
                        .catch(reason => {                            
                            dialog.alert('An error occurred saving the template. Please try again.', 'Error');
                        });
                }
                else {
                    this.newUpdateOrSave(payload);
                }
            }
        }
    }

    newUpdateOrSave(payload: TextTemplateDto) {
      if(payload.TextTemplateId === this.defaultValue().TextTemplateId){
            this.textTemplateService.insertTextTemplate(payload)
            .then(result => {
                this.showingDialog = false;
            })
            .catch(error => {

            }); 
        }
        else {
            this.textTemplateService.updateTextTemplate(payload)
            .then(result => {
                this.showingDialog = false;
            })
            .catch(error => {

            });
        }
    }
    

    hidingDialog(e: any){
        this.showingDialog = false;
    }

    onPopuphidden(e:any) {
      this.textTemplate = this.defaultValue();
      this.allAvailableAutoText = this.availableAutoText();
      
    }
    onPopupShowing(e:any) {
      this.saveAsOption = this.textBoxOption();
    }

    onPopupShown(e: any) {
      let value: any[] = [];
      for (const key in TextTemplateTypeEnum) {
        let propValue = parseInt(key, 10) >= 0;
        if (propValue) {
          value.push({
            'key': key,
            'value': TextTemplateTypeEnum[key].split(/(?=[A-Z])/).join(' ')
          });
        }
      }

      this.textTemplateType = _.sortBy(value, t => t.value);
      this.validationGroup.reset();
    }
}
